// RoleBasedSidebar.js
import React from "react";
import OfficeSidebar from "./OfficeSidebar";
import UserSidebar from "./UserSidebar";

const RoleBasedSidebar = ({ isOpen, onClose }) => {
  const worker = JSON.parse(localStorage.getItem("worker"));
  if (!worker) return null;

  if (worker.role === "Office") {
    return <OfficeSidebar isOpen={isOpen} onClose={onClose} />;
  } else if (
    worker.role === "Developer"     ||
    worker.role === "Designer"      ||
    worker.role === "TL"            ||
    worker.role === "Marketing"     ||
    worker.role === "HR & Design"   ||
    worker.role === "Project Leads"
  ) {
    return <UserSidebar isOpen={isOpen} onClose={onClose} />;
  } else {
    return null;
  }
};

export default RoleBasedSidebar;